<h2>Barcode Mapping</h2>
<div class="px-2 py-3 contents h-full max-h-80" *ngIf="isLoadBarcodeMappingGridWithGlobalCompanyPrefixGridSource">
<!--    Checkbox filter. Filter by SourceBarcodeIsExcluded -->
    <div class="mapping-grid-container shadow-lg">
        <dx-data-grid
            #barcodeMappingGridWithGlobalCompanyPrefixGrid
            id="barcodeMappingGridWithGlobalCompanyPrefixGrid"
            [allowColumnResizing]="true"
            [columnResizingMode]="'widget'"
            [allowColumnReordering]="true"
            [dataSource]="barcodeMappingGridWithGlobalCompanyPrefixGridDataSource"
            [showBorders]="true"
            [columnAutoWidth]="true"
            [remoteOperations]="true"
            [hoverStateEnabled]="true"
            [(selectedRowKeys)]="barcodeMappingGridWithGlobalCompanyPrefixGridSelectedRowMap"
            (onSelectionChanged)="selectionBarcodeMappingGridWithGlobalCompanyPrefixGridChangedHandler()"
            (onContentReady)="onReady($event)"
            (onContextMenuPreparing)="barcodeMappingGridWithGlobalCompanyPrefixGridContextMenu($event)"
            (onRowExpanding)="onRowExpanding($event)"
            (onRowExpanded)="onRowExpanded($event)"
        >
            <dxo-state-storing
                    [enabled]="true"
                    type="custom"
                    [customLoad]="loadBarcodeMappingGridWithGlobalCompanyPrefixGridState"
                    [customSave]="saveProductBarcodeMasterState"
            ></dxo-state-storing>
            <dxo-load-panel
                    [enabled]="false"
                    shadingColor="rgba(0,0,0,0.4)"
                    [showIndicator]="true"
                    [showPane]="true"
                    [shading]="true">
            </dxo-load-panel>
            <dxo-filter-panel [visible]="true"></dxo-filter-panel>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-pager
                    [visible]="true"
                    [allowedPageSizes]="[5, 10, 25, 50, 100]"
                    displayMode="compact"
                    [showPageSizeSelector]="true"
                    [showNavigationButtons]="false"
            >
            </dxo-pager>
            <dxo-paging [pageSize]="5"></dxo-paging>
            <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>
            <dxo-selection mode="single"></dxo-selection>
            <dxo-column-chooser [enabled]="true" mode="dragAndDrop"></dxo-column-chooser>
            <dxi-column caption="Action" cellTemplate="action" alignment="center" [allowHeaderFiltering]="false"></dxi-column>
            <dxi-column dataField="BarcodeMappingId" caption="Barcode Mapping ID" [allowHeaderFiltering]="false" [width]="140" [customizeText]="customizeBarcodeMappingId"></dxi-column>
            <dxi-column caption="Source Data - Barcode">
                <dxi-column dataField="SourceBarcode" caption="Source Barcode">
                    <dxo-header-filter [dataSource]="sourceBarcodeHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="CleanBarcode" caption="Clean Barcode">
                    <dxo-header-filter [dataSource]="cleanBarcodeHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="HasValidChecksumDigit" caption="Valid Checksum Digit" [visible]="false" [allowHeaderFiltering]="false"></dxi-column>
                <dxi-column dataField="IsValidBarcode" caption="Valid Barcode" [allowHeaderFiltering]="false"></dxi-column>
                <dxi-column dataField="IsVerifiedBarcode" caption="Verified Barcode" [allowHeaderFiltering]="false"></dxi-column>
            </dxi-column>
            <dxi-column caption="Global Company Prefix">
                <dxi-column dataField="BarcodeGlobalCompanyPrefixMappingId" caption="GCP Mapping ID" [visible]="false" [allowHeaderFiltering]="false" [width]="140" [customizeText]="customizeBarcodeGlobalCompanyPrefixMappingId"></dxi-column>
                <dxi-column dataField="GlobalCompanyPrefix" caption="Prefix">
                    <dxo-header-filter [dataSource]="globalCompanyPrefixHeaderDataSource"></dxo-header-filter>
                </dxi-column>

                <dxi-column dataField="BarcodeGlobalCompanyPrefixMappingModeId" caption="Mapping Mode ID" [allowHeaderFiltering]="false"></dxi-column>
                <dxi-column dataField="BarcodeGlobalCompanyPrefixMappingModeKey" caption="Mapping Mode Key" [allowHeaderFiltering]="false"></dxi-column>
                <dxi-column dataField="BarcodeGlobalCompanyPrefixMappingModeName" caption="Mapping Mode Name" [allowHeaderFiltering]="false"></dxi-column>
            </dxi-column>
            <dxi-column dataField="MappingModeId" caption="Mapping Mode ID" [allowHeaderFiltering]="false"></dxi-column>
            <dxi-column dataField="MappingModeKey" caption="Mapping Mode Key" [allowHeaderFiltering]="false"></dxi-column>
            <dxi-column dataField="MappingModeName" caption="Mapping Mode Name" [allowHeaderFiltering]="false"></dxi-column>
            <dxi-column dataField="MappingPriority" caption="Mapping Priority">
                <dxo-header-filter [dataSource]="mappingPriorityHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="MappingAssignedToUserId" caption="Mapping Assigned To User ID">
                <dxo-header-filter [dataSource]="mappingAssignedToUserIdHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="MappingAssignedToUserFullNameSortableOrPrincipalName" caption="Mapping Assigned To User" [allowHeaderFiltering]="false"></dxi-column>
            <dxi-column dataField="ProductBarcodeMappingsCount" caption="Product Barcode Mappings Count">
                <dxo-header-filter [dataSource]="productBarcodeMappingsCountHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="InconsistentProductBarcodeMappingsExists" caption="Inconsistent Barcode Mappings Exist" [allowHeaderFiltering]="false"></dxi-column>
            <dxi-column dataField="InconsistentProductBarcodeMappingsCount" caption="Inconsistent Barcode Mappings Count" [allowHeaderFiltering]="false"></dxi-column>
            <dxi-column dataField="InconsistentServiceAndProductMappingExists" caption="Inconsistent Product Mapping Exists" [allowHeaderFiltering]="false"></dxi-column>
            <dxi-column dataField="InconsistentServiceAndProductMappingsCount" caption="Inconsistent product Mappings Count">
                <dxo-header-filter [dataSource]="inconsistentServiceAndProductMappingsCountHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column caption="Mapped To">
                <dxi-column dataField="ProductBarcodeId" caption="Product Barcode ID" [customizeText]="customizeProductBarcodeId">
                    <dxo-header-filter [dataSource]="productBarcodeIdHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="QuantityMultiplier" caption="Quantity Multiplier">
                    <dxo-header-filter [dataSource]="quantityMultiplierHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ProductBarcodeIsActive" caption="Product Barcode Is Active" [visible]="false">
                    <dxo-header-filter [dataSource]="productBarcodeIsActiveHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ProductMasterId" caption="Product Master ID" [customizeText]="customizeProductMasterId">
                    <dxo-header-filter [dataSource]="productMasterIdHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="CompanyId" caption="Company ID" [visible]="false">
                    <dxo-header-filter [dataSource]="companyIdHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="CompanyName" caption="Company Name">
                    <dxo-header-filter [dataSource]="companyNameMappingHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="MasterBrandId" caption="Master Brand ID" [visible]="false">
                    <dxo-header-filter [dataSource]="masterBrandIdHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="MasterBrandName" caption="Master Brand Name">
                    <dxo-header-filter [dataSource]="masterBrandNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="BrandId" caption="Brand ID">
                    <dxo-header-filter [dataSource]="brandIdHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="BrandName" caption="Brand Name">
                    <dxo-header-filter [dataSource]="brandNameMappingHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="SubBrandId" caption="Sub Brand ID" [visible]="false">
                    <dxo-header-filter [dataSource]="subBrandIdHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="SubBrandName" caption="Sub Brand Name">
                    <dxo-header-filter [dataSource]="subBrandNameMappingHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ProductId" caption="Product ID" [visible]="false">
                    <dxo-header-filter [dataSource]="productIdHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ProductName" caption="Product Name">
                    <dxo-header-filter [dataSource]="productNameMappingHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ProductIsNatureInspired" caption="Product Is Nature Inspired" [visible]="false">
                    <dxo-header-filter [dataSource]="productIsNatureInspiredHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ProductIsMensProduct" caption="Product Is Men's Product" [visible]="false">
                    <dxo-header-filter [dataSource]="productIsMensProductHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ProductIsDiscontinued" caption="Product Is Discontinued" [visible]="false">
                    <dxo-header-filter [dataSource]="productIsDiscontinuedHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="CategoryId" caption="Category ID" [visible]="false">
                    <dxo-header-filter [dataSource]="categoryIdHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="CategoryName" caption="Category Name">
                    <dxo-header-filter [dataSource]="categoryNameMappingHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="SubcategoryFormId" caption="Subcategory Form ID" [visible]="false">
                    <dxo-header-filter [dataSource]="subcategoryFormIdHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="SubcategoryFormName" caption="Subcategory Form Name">
                    <dxo-header-filter [dataSource]="subcategoryFormNameMappingHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="SubcategoryFunctionId" caption="Subcategory Function ID">
                    <dxo-header-filter [dataSource]="subcategoryFunctionIdHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="SubcategoryFunctionName" caption="Subcategory Function Name">
                    <dxo-header-filter [dataSource]="subcategoryFunctionNameMappingHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ProductSizeOnLabel" caption="Product Size On Label">
                    <dxo-header-filter [dataSource]="productSizeOnLabelMappingHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="PackagingTypeId" caption="Packaging Type ID" [visible]="false">
                    <dxo-header-filter [dataSource]="packagingTypeIdHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="PackagingTypeName" caption="Packaging Type Name">
                    <dxo-header-filter [dataSource]="packagingTypeNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ProductMasterIsDiscontinued" caption="Product Master Is Discontinued">
                    <dxo-header-filter [dataSource]="productMasterIsDiscontinuedHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ProductMasterIsActive" caption="Product Master Is Active">
                    <dxo-header-filter [dataSource]="productMasterIsActiveHeaderDataSource"></dxo-header-filter>
                </dxi-column>
            </dxi-column>
            <dxi-column caption="Data Auditing">
                <dxi-column dataField="CreatedOn" caption="Created On" dataType="date" format="M/d/yyyy, HH:mm" dataType="datetime" [visible]="false" cssClass="hide-filter-icon">
                    <dxo-header-filter [dataSource]="createdOnHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="CreatedByUserId" caption="Created By User ID" [visible]="false" [allowHeaderFiltering]="false"></dxi-column>
                <dxi-column dataField="CreatedByUserFullNameSortableOrPrincipalName" caption="Created By User">
                    <dxo-header-filter [dataSource]="createdByUserFullNameSortableOrPrincipalNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>

                <dxi-column dataField="ModifiedOn" caption="Modified On" dataType="date" format="M/d/yyyy, HH:mm" dataType="datetime" [visible]="false" cssClass="hide-filter-icon">
                    <dxo-header-filter [dataSource]="modifiedOnHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ModifiedByUserId" caption="Modified By User ID" [visible]="false" [allowHeaderFiltering]="false"></dxi-column>
                <dxi-column dataField="ModifiedByUserFullNameSortableOrPrincipalName" caption="Modified By User">
                    <dxo-header-filter [dataSource]="modifiedByUserFullNameSortableOrPrincipalNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>

                <dxi-column dataField="ReviewedOn" caption="Reviewed On" dataType="date" format="M/d/yyyy, HH:mm" dataType="datetime" [visible]="false" cssClass="hide-filter-icon">
                    <dxo-header-filter [dataSource]="reviewedOnHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ReviewedByUserId" caption="Reviewed By User ID" [visible]="false" [allowHeaderFiltering]="false"></dxi-column>
                <dxi-column dataField="ReviewedByUserFullNameSortableOrPrincipalName" caption="Reviewed By User">
                    <dxo-header-filter [dataSource]="reviewedByUserFullNameSortableOrPrincipalNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
            </dxi-column>

            <dxi-column dataField="Active" caption="Active" [allowHeaderFiltering]="false"></dxi-column>
            <div *dxTemplate="let action of 'action'">
                <dx-button class="mr-1" icon="fas fa-ban fa-1x" hint="Omit" [disabled]="action?.data?.MappingModeId == 3" (onClick)="omit(action?.data?.BarcodeMappingId)"></dx-button>
                <dx-button class="mr-1" icon="far fa-bookmark fa-1x" hint="Save" [disabled]="action?.data?.MappingModeId == 2" (onClick)="save(action?.data?.BarcodeMappingId)"></dx-button>
                <dx-button
                        id="btnAccept"
                        *ngIf="action?.data?.ModifiedByUserId <= 0 && action?.data?.MappingModeId == 0"
                        class="mr-1"
                        icon="fa fa-check fa-1x"
                        hint="Accept"
                        (onClick)="accept(action?.data?.BarcodeMappingId)"
                ></dx-button>
                <dx-button
                        id="btnReview"
                        class="mr-1"
                        *ngIf="action?.data?.ModifiedByUserId > 0 && action?.data?.ModifiedByUserId != currentUser?.UserId && action?.data?.ReviewedByUserId == -1"
                        icon="fas fa-check-double fa-1x"
                        hint="Review"
                        (onClick)="review(action?.data?.BarcodeMappingId)"
                ></dx-button>
<!--                <dx-button-->
<!--                        id="btnAcceptMapping"-->
<!--                        *ngIf="action?.data?.Ranking >= 0 && action?.data?.MappingModeId == 1 && (action?.data?.ProductBarcodeId != 0) && action?.data?.CurrentProductBarcodeId == action?.data?.ProductBarcodeId"-->
<!--                        class="mr-1"-->
<!--                        icon="fas fa-map-marker-alt fa-1x"-->
<!--                        hint="Accept Mapping"-->
<!--                        (onClick)="acceptMapping(action?.data?.BarcodeMappingId)"></dx-button>-->
                <dx-button *ngIf="currentUser?.UserRoleId > 1 && action?.data?.Active" icon="fas fa-trash-alt fa-1x" hint="Deactivate" (onClick)="deactivate(action?.data?.BarcodeMappingId)"></dx-button>
                <dx-button *ngIf="currentUser?.UserRoleId > 1 && !action?.data?.Active" icon="fas fa-trash-alt fa-1x" hint="Reactivate" (onClick)="reactivate(action?.data?.BarcodeMappingId)"></dx-button>
            </div>
            <dxo-master-detail
                    [enabled]="true"
                    template="masterDetail"
            ></dxo-master-detail>

            <div *dxTemplate="let masterDetailItem of 'masterDetail'">
                <app-barcode-detail-view
                        [key]="masterDetailItem.key"
                ></app-barcode-detail-view>
            </div>
        </dx-data-grid>

    </div>
</div>

<div *ngIf="isLoadProductBarcodeMasterDataSource">
    <div dragula="HANDLES3" id="left">
        <div class="mapping-grid-container shadow-lg mt-2">
            <span class="handle"><i class="fa fa-arrows" aria-hidden="true"></i></span>
            <div class="py-2 h-full">
                <dx-data-grid
                    #barcodeMappingToMasterGrid
                    id="barcodeMappingToMasterGrid"
                    [allowColumnResizing]="true"
                    [columnResizingMode]="'widget'"
                    [allowColumnReordering]="true"
                    [dataSource]="barcodeMappingToMasterGridDataSource"
                    [showBorders]="true"
                    [columnAutoWidth]="true"
                    [hoverStateEnabled]="true"
                    (onContextMenuPreparing)="barcodeMappingToMasterGridContextMenu($event)"
                >
                    <dxo-load-panel
                            [enabled]="false"
                            shadingColor="rgba(0,0,0,0.4)"
                            [showIndicator]="true"
                            [showPane]="true"
                            [shading]="true">
                    </dxo-load-panel>
                    <dxo-selection mode="single"></dxo-selection>
                    <dxi-column dataField="MappingSource"></dxi-column>
                    <dxi-column caption="Action" cellTemplate="action" alignment="center"></dxi-column>
                    <dxi-column dataField="BarcodeMappingIdCount"></dxi-column>
                    <dxi-column dataField="MappingModeId"></dxi-column>
                    <dxi-column dataField="MappingModeName"></dxi-column>
                    <dxi-column dataField="ProductBarcodeId" [allowHeaderFiltering]="false" [width]="140" [customizeText]="customizeProductBarcodeId"></dxi-column>
                    <dxi-column dataField="Barcode"></dxi-column>
                    <dxi-column dataField="IsInconsistentBarcodeMapping"></dxi-column>
                    <dxi-column dataField="ServiceAndProductMappingModeId"></dxi-column>
                    <dxi-column dataField="ServiceAndProductMappingModeName"></dxi-column>
                    <dxi-column dataField="ProductMasterId" [allowHeaderFiltering]="false" [width]="140" [customizeText]="customizeProductMasterId"></dxi-column>
                    <dxi-column dataField="IsInconsistentProductMapping"></dxi-column>
                    <dxi-column dataField="CompanyName"></dxi-column>
                    <dxi-column dataField="MasterBrandName"></dxi-column>
                    <dxi-column dataField="BrandName"></dxi-column>
                    <dxi-column dataField="SubBrandName"></dxi-column>
                    <dxi-column dataField="ProductName"></dxi-column>
                    <dxi-column dataField="ProductIsNatureInspired"></dxi-column>
                    <dxi-column dataField="ProductIsMensProduct"></dxi-column>
                    <dxi-column dataField="CategoryName"></dxi-column>
                    <dxi-column dataField="SubcategoryFormName"></dxi-column>
                    <dxi-column dataField="SubcategoryFunctionName"></dxi-column>
                    <dxi-column dataField="ProductSizeOnLabel"></dxi-column>

                    <div *dxTemplate="let action of 'action'">
                        <dx-button
                                id="btnMiddleOmit"
                                *ngIf="action?.data?.Ranking == -1"
                                class="mr-1"
                                icon="fas fa-ban fa-1x"
                                hint="Omit"
                                [disabled]="action?.data?.CurrentMappingModeId == 3"
                                (onClick)="omitMiddle(action?.data?.CurrentBarcodeMappingId)"></dx-button>
                        <dx-button
                                id="btnMiddleSave"
                                *ngIf="action?.data?.Ranking == -1"
                                class="mr-1"
                                icon="far fa-bookmark fa-1x"
                                hint="Save"
                                [disabled]="action?.data?.CurrentMappingModeId == 2"
                                (onClick)="saveMiddle(action?.data?.CurrentBarcodeMappingId)"></dx-button>
                        <dx-button
                                id="btnMiddleAccept"
                                *ngIf="action?.data?.Ranking == -1 &&
                                !(barcodeMappingGridWithGlobalCompanyPrefixGridSelectedRowMap.ModifiedByUserId > 0 || (action?.data?.CurrentMappingModeId == 0 && action?.data?.CurrentProductMasterId == 0))"
                                class="mr-1"
                                icon="fa fa-check fa-1x"
                                hint="Accept"
                                (onClick)="acceptMiddle(action?.data?.CurrentBarcodeMappingId)"></dx-button>
                        <!-- need icon -->
                        <dx-button
                                id="btnMiddleReview"
                                *ngIf="
                                action?.data?.Ranking == -1 &&
                                currentUser.UserRoleId > 1 &&
                                barcodeMappingGridWithGlobalCompanyPrefixGridSelectedRowMap.MappingModeId !== 0 &&
                                barcodeMappingGridWithGlobalCompanyPrefixGridSelectedRowMap.ModifiedByUserId > 0 &&
                                barcodeMappingGridWithGlobalCompanyPrefixGridSelectedRowMap.ModifiedByUserId !== currentUser.UserId &&
                                barcodeMappingGridWithGlobalCompanyPrefixGridSelectedRowMap.ReviewedByUserId == -1"
                                class="mr-1"
                                icon="fas fa-check-double fa-1x"
                                hint="Review"
                                (onClick)="reviewMiddle(action?.data?.CurrentBarcodeMappingId)"></dx-button>
                        <dx-button
                                id="btnMiddleAcceptOmit"
                                *ngIf="action?.data?.Ranking >= 0 && ((action?.data?.ServiceAndProductMappingModeId === null && action?.data?.MappingModeId == 3) || (action?.data?.ServiceAndProductMappingModeId == 3)) && action?.data?.CurrentMappingModeId !== 3"
                                class="mr-1"
                                icon="fas fa-ban fa-1x"
                                hint="Accept Omit"
                                (onClick)="acceptOmitMiddle(action?.data?.CurrentBarcodeMappingId)"></dx-button>
                        <!-- need icon -->
                        <dx-button
                                id="btnMiddleAcceptSave"
                                *ngIf="action?.data?.Ranking >= 0 &&
                                (
                                    (action?.data?.ServiceAndProductMappingModeId === null && action?.data?.MappingModeId == 2) || (action?.data?.ServiceAndProductMappingModeId == 2)
                                ) && action?.data?.CurrentMappingModeId !== 2"
                                class="mr-1"
                                icon="far fa-bookmark fa-1x"
                                hint="Accept Save"
                                (onClick)="acceptSaveMiddle(action?.data?.CurrentBarcodeMappingId)"></dx-button>
                        <!-- need icon -->
                        <dx-button
                                id="btnMiddleAcceptMapping"
                                *ngIf="action?.data?.Ranking >= 0 &&
                                ((action?.data?.ServiceAndProductMappingModeId === null && action?.data?.MappingModeId == 1) || (action?.data?.ServiceAndProductMappingModeId == 1)) &&
                                action?.data?.ProductBarcodeId && action?.data?.CurrentProductBarcodeId !== action?.data?.ProductBarcodeId"
                                class="mr-1"
                                icon="fas fa-map-marker-alt fa-1x"
                                hint="Accept Mapping"
                                (onClick)="acceptMiddleMapping(action?.data?.CurrentBarcodeMappingId, action?.data?.ProductBarcodeId)"></dx-button>
                        <!-- need icon -->
                        <ng-container *ngIf="action?.data?.Ranking >= 0">
                            <i class="fas fa-concierge-bell text-xl" style="font-size: 1.25rem;" *ngIf="isEligibleForProductBarcodeReassignment(action?.data)" title="Right-click for more"></i>
                        </ng-container>
                    </div>
                </dx-data-grid>
            </div>
        </div>
        <div class="mapping-grid-container shadow-lg mt-2">
            <span class="handle mr-3"><i class="fa fa-arrows" aria-hidden="true"></i></span>
            <div class="mt-2 h-full">
                <dx-data-grid
                    #productBarcodeMasterGrid
                    id="productBarcodeMasterGrid"
                    [allowColumnResizing]="true"
                    [columnResizingMode]="'widget'"
                    [allowColumnReordering]="true"
                    [dataSource]="productBarcodeMasterDataSource"
                    [showBorders]="true"
                    [columnAutoWidth]="true"
                    [remoteOperations]="true"
                    [hoverStateEnabled]="true"
                    [(selectedRowKeys)]="productBarcodeMasterGridSelectedRowMap"
                    (onSelectionChanged)="selectionProductBarcodeMasterChangedHandler()"
                    (onContentReady)="onReady($event)"
                    (onContextMenuPreparing)="productBarcodeMasterDataGridContextMenu($event)"
                >
                    <dxo-state-storing
                            [enabled]="true"
                            type="custom"
                            [customLoad]="loadProductBarcodeMasterState"
                            [customSave]="saveProductBarcodeMasterState"
                    ></dxo-state-storing>
                    <dxo-load-panel
                            [enabled]="false"
                            shadingColor="rgba(0,0,0,0.4)"
                            [showIndicator]="true"
                            [showPane]="true"
                            [shading]="true">
                    </dxo-load-panel>
                    <dxo-filter-panel [visible]="true"></dxo-filter-panel>
                    <dxo-filter-row [visible]="true"></dxo-filter-row>
                    <dxo-pager
                            [visible]="true"
                            [allowedPageSizes]="[5, 10, 25, 50, 100]"
                            displayMode="compact"
                            [showPageSizeSelector]="true"
                            [showNavigationButtons]="false"
                    >
                    </dxo-pager>
                    <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>
                    <dxo-selection mode="single"></dxo-selection>
                    <dxo-column-chooser [enabled]="true" mode="dragAndDrop"></dxo-column-chooser>
                    <dxi-column caption="Action" [allowHeaderFiltering]="false" cellTemplate="action" [width]="100" alignment="center"></dxi-column>
                    <dxi-column dataField="ProductBarcodeId" [allowHeaderFiltering]="false" [width]="140" [customizeText]="customizeProductBarcodeId"></dxi-column>
                    <dxi-column dataField="Barcode"></dxi-column>
                    <dxi-column dataField="QuantityMultiplier" [visible]="false"></dxi-column>
                    <dxi-column dataField="ProductMasterId" [allowHeaderFiltering]="false" [width]="140" [customizeText]="customizeProductMasterId"></dxi-column>
                    <dxi-column dataField="CompanyName">
                        <dxo-header-filter [dataSource]="companyNameHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="MasterBrandName" caption="Master Brand">
                        <dxo-header-filter [dataSource]="masterBrandHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="BrandName" caption="Brand">
                        <dxo-header-filter [dataSource]="brandNameHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="SubBrandName" caption="Sub-brand">
                        <dxo-header-filter [dataSource]="subBrandNameHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="ProductName" caption="Product">
                        <dxo-header-filter [dataSource]="productNameHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="ProductIsNatureInspired" caption="Nature Inspired" [allowHeaderFiltering]="false"></dxi-column>
                    <dxi-column dataField="ProductIsMensProduct" caption="Men's Product" [allowHeaderFiltering]="false"></dxi-column>
                    <dxi-column dataField="CategoryName" caption="Category">
                        <dxo-header-filter [dataSource]="categoryNameHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="SubcategoryFunctionName" caption="Function Subcategory">
                        <dxo-header-filter [dataSource]="subcategoryFunctionNameHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="SubcategoryFormName" caption="Form Subcategory">
                        <dxo-header-filter [dataSource]="subcategoryFormNameHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="ProductSizeOnLabel" caption="Product Size On Label">
                        <dxo-header-filter [dataSource]="productSizeOnLabelHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="ProductMasterBarcodeList"></dxi-column>
                    <dxi-column dataField="Active"></dxi-column>
                    <div *dxTemplate="let action of 'action'">
                        <dx-button
                                class="mr-1"
                                icon="fas fa-map-marker-alt fa-1x"
                                hint="Map"
                                (onClick)="map(action?.data?.BarcodeMappingId, action?.data?.ProductBarcodeId)"></dx-button>
                    </div>
                    <dxo-paging [pageSize]="5"></dxo-paging>
                </dx-data-grid>
            </div>
        </div>
    </div>
</div>
